<svg class="svg_icon--drag_handle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
  <defs>
    <style>.svg_icon--drag_handle .icon{fill:currentColor;}</style>
  </defs>
  <title>Drag</title>
  <g>
    <path class="icon"
          d="m33.57,11.35c5.53,0,9.62,4.09,9.62,9.4v.22c0,5.31-4.09,9.4-9.62,9.4s-9.62-4.09-9.62-9.4v-.22c0-5.31,4.09-9.4,9.62-9.4Z"/>
    <path class="icon"
          d="m66.53,11.35c5.53,0,9.62,4.09,9.62,9.4v.22c0,5.31-4.09,9.4-9.62,9.4s-9.62-4.09-9.62-9.4v-.22c0-5.31,4.09-9.4,9.62-9.4Z"/>
    <path class="icon"
          d="m33.57,41.59c5.53,0,9.62,4.09,9.62,9.4v.22c0,5.31-4.09,9.4-9.62,9.4s-9.62-4.09-9.62-9.4v-.22c0-5.31,4.09-9.4,9.62-9.4Z"/>
    <path class="icon"
          d="m66.53,41.59c5.53,0,9.62,4.09,9.62,9.4v.22c0,5.31-4.09,9.4-9.62,9.4s-9.62-4.09-9.62-9.4v-.22c0-5.31,4.09-9.4,9.62-9.4Z"/>
    <path class="icon"
          d="m33.57,71.56c5.53,0,9.62,4.09,9.62,9.4v.22c0,5.31-4.09,9.4-9.62,9.4s-9.62-4.09-9.62-9.4v-.22c0-5.31,4.09-9.4,9.62-9.4Z"/>
    <path class="icon"
          d="m66.53,71.56c5.53,0,9.62,4.09,9.62,9.4v.22c0,5.31-4.09,9.4-9.62,9.4s-9.62-4.09-9.62-9.4v-.22c0-5.31,4.09-9.4,9.62-9.4Z"/>
  </g>
</svg>